// 质检相关路由
export default {
  routes: [
    // 质检氛围页
    {
      path: '/(\\s*)check(\\d*)/(\\s*)atmosphere(\\d*)',
      name: 'CheckAtmosphere',
      meta: {
        desc: '质检氛围页'
      },
      component: () =>
        import(/* webpackChunkName: "CheckAtmosphere" */ '../views/check/atmosphere/index.vue')
    },
    // 质检介绍页
    {
      path: '/check/introduce',
      name: 'CheckIntroduce',
      meta: {
        desc: '质检介绍页'
      },
      component: () =>
        import(/* webpackChunkName: "CheckIntroduce" */ '../views/check/introduce/index.vue')
    },
    {
      path: '/check/introduce-b',
      name: 'CheckIntroduceB',
      meta: {
        desc: '真的官方验'
      },
      component: () =>
        import(/* webpackChunkName: "CheckIntroduceB" */ '../views/check/introduce/indexB.vue')
    },
    {
      path: '/check/introduce-c',
      name: 'CheckIntroduceC',
      meta: {
        desc: '真的官方验',
        pageId: 'J3930'
      },
      component: () =>
        import(/* webpackChunkName: "CheckIntroduceC" */ '../views/check/introduce/indexC.vue')
    },
    {
      path: '/check/introduce-d',
      name: 'CheckIntroduceD',
      meta: {
        desc: '真的官方验',
        pageId: 'H3226'
      },
      component: () =>
        import(/* webpackChunkName: "CheckIntroduceC" */ '../views/check/introduce/indexD.vue')
    },
    {
      path: '/check/appraiser-card',
      name: 'AppraiserCard',
      meta: {
        desc: '质检师介绍',
        pageId: 'G5882'
      },
      component: () =>
        import(
          /* webpackChunkName: "CheckIntroduceC" */ '../views/check/introduce/appraiserCard.vue'
        )
    }
  ]
}
